import WelcomeScreen from "./Welcome/welcomeScreen";
import DepartmentPrice from "./departmentPrice/departmentPrice";
import Department from "./department/department";
import PatientProfile from "./patientProfle/patientProfile";
import PageNotFound from "./pageNotFound/pageNotFound";
import DriverProfile from "./driverProfile/DriverProfile";
import Ambulance from "./ambulance/Ambulance";
import NurseRequest from "./nursingCare/NurseRequest";
import ServiceDetails from "./nursingCare/ServiceDetials";
import Article from "./healthArticles/Article";
import NationalID from "./nationalId/NationalID";
import TermsCondition from "./terms-condition/tnc";
import ApprovedRequestDetailsPage from "./nursingCare/ApprovedRequestDetailsPage";
import SessionDetailsPage from "./nursingCare/SessionDetailsPage";
import ViewRequestDetailsPage from "./nursingCare/ViewRequestDetailsPage";
import ReallocationLogPage from "./nursingCare/ReallocationLogPage";
import DeletedSessionDetailsPage from "./nursingCare/DeletedSessionDetailsPage";
import DeletedRequestDetailsPage from "./nursingCare/DeletedRequestDetailsPage";

const Pages = {
  WelcomeScreen,
  DepartmentPrice,
  Department,
  PatientProfile,
  PageNotFound,
  DriverProfile,
  Ambulance,
  ServiceDetails,
  NurseRequest,
  Article,
  NationalID,
  TermsCondition,
  ApprovedRequestDetailsPage,
  SessionDetailsPage,
  ViewRequestDetailsPage,
  ReallocationLogPage,
  DeletedSessionDetailsPage,
  DeletedRequestDetailsPage,
};

export default Pages;
